import { render, staticRenderFns } from "./wxShare.vue?vue&type=template&id=dbd8a868&scoped=true&"
import script from "./wxShare.vue?vue&type=script&lang=js&"
export * from "./wxShare.vue?vue&type=script&lang=js&"
import style0 from "./wxShare.vue?vue&type=style&index=0&id=dbd8a868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd8a868",
  null
  
)

export default component.exports